import React from 'react';
import { useParams } from 'react-router-dom';
import JitsiLiveClass from '../components/JitsiLiveClass';

const EtudiantLiveCours = () => {
  const { cours } = useParams();

  // يمكنك توليد اسم غرفة بناءً على الدورة والتاريخ
  const today = new Date().toISOString().split('T')[0];
  const roomName = `Zettat_${cours.replace(/\s+/g, '_')}_${today}`;

  return (
    <div style={{ padding: '20px' }}>
      <h1>📡 بث مباشر لدورة: {cours}</h1>
      <JitsiLiveClass roomName={roomName} />
    </div>
  );
};

export default EtudiantLiveCours;
